import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AuditTrailConfigurationDTO  {
    _originalTypeClassName = "zERP.BO.AuditTrailConfigurationDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AuditTrailConfigurationDTO.translate = translateService;
}
this.FullName = null;
this.TotalProperties = null;
this.AuditableProperties = null;
this.ShortName = null;
this.IsSelected = false;
this.AuditTrailConfigurationDTOKey = null;
this._key = this.AuditTrailConfigurationDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
FullName:any;
TotalProperties:any;
AuditableProperties:any;
ShortName:any;
IsSelected:any;
private _AuditTrailConfigurationDTOKey:any;
get AuditTrailConfigurationDTOKey(): any {
    return this._AuditTrailConfigurationDTOKey;
  }
set AuditTrailConfigurationDTOKey(value: any) {
    this._AuditTrailConfigurationDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AuditTrailConfigurationDTOKey == null || $this.AuditTrailConfigurationDTOKey == 0;
            }


}